import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS, Document } from "@contentful/rich-text-types";
import React, { ReactNode } from "react";
import classes from "./documentToNode.module.css";

interface FTCDisclosure {
    checkbox1text: ReactNode;
    checkbox2text: ReactNode;
    mainText: ReactNode;
    nyAddendum?: ReactNode;
}

interface FTCDisclosureInput {
    checkbox1text: Document;
    checkbox2text: Document;
    mainText: Document;
    nyAddendum?: Document;
}

export function buildFTCDisclosures(disclosure: FTCDisclosureInput): FTCDisclosure {
    return {
        checkbox1text: documentToReactComponents(disclosure.checkbox1text, {
            renderNode: {
                [BLOCKS.PARAGRAPH]: (_node, children) => <p className={classes.paragraph}>{children}</p>,
                [BLOCKS.LIST_ITEM]: (_node, children) => <li className={classes.listItem}>{children}</li>,
                [BLOCKS.UL_LIST]: (_node, children) => <ul className={classes.unorderedList}>{children}</ul>,
            },
        }),

        checkbox2text: documentToReactComponents(disclosure.checkbox2text, {
            renderNode: {
                [BLOCKS.PARAGRAPH]: (_node, children) => <p className={classes.paragraph}>{children}</p>,
                [BLOCKS.LIST_ITEM]: (_node, children) => <li className={classes.listItem}>{children}</li>,
                [BLOCKS.UL_LIST]: (_node, children) => <ul className={classes.unorderedList}>{children}</ul>,
            },
        }),

        mainText: documentToReactComponents(disclosure.mainText, {
            renderNode: {
                [BLOCKS.PARAGRAPH]: (_node, children) => <p className={classes.paragraph}>{children}</p>,
                [BLOCKS.LIST_ITEM]: (_node, children) => <li className={classes.listItem}>{children}</li>,
                [BLOCKS.UL_LIST]: (_node, children) => <ul className={classes.unorderedList}>{children}</ul>,
            },
        }),

        nyAddendum: disclosure.nyAddendum
            ? documentToReactComponents(disclosure.nyAddendum, {
                  renderNode: {
                      [BLOCKS.PARAGRAPH]: (_node, children) => <p className={classes.paragraph}>{children}</p>,
                      [BLOCKS.LIST_ITEM]: (_node, children) => <li className={classes.listItem}>{children}</li>,
                      [BLOCKS.UL_LIST]: (_node, children) => <ul className={classes.unorderedList}>{children}</ul>,
                  },
              })
            : undefined,
    };
}
